<div class="background-container">
  <div class="iscriviti-container grid py-5">
    <div class="row text-center">
      <h2 class="blue-50 bold">Entra nel mondo Easycode</h2>
    </div>

    <div class="container">
      <div class="row mt-5">
        <div
          class="col-xl d-flex justify-content-center justify-content-xl-end mb-5 mb-xl-0 d-none d-lg-flex"
        >
          <div class="isc-card-1" index="1">
            <img
              src="../../../assets/img/educatori_digitali.png"
              alt="iscriviti"
             
            />
            <div class="card-text">
              <h3 class="w-700">Diventa un educatore</h3>
              <p class="card-description">
                Entra a far parte della nostra squadra in costante crescita di
                educatori digitali. Mandaci una tua candidatura e ti
                contatteremo presto!
              </p>
              <button class="btn-lightblue m-custom mt-4">
                <span class="button-txt" (click)="openModal('E')"
                  >Invia la tua candidatura</span
                >
              </button>
            </div>
          </div>
        </div>

        <div
          class="col-xl d-flex justify-content-center justify-content-xl-start d-none d-lg-block"
        >
          <div class="isc-card-2" index="2">
            <img
              src="../../../assets/img/scuole.png"
              alt="scuole"
             
            />
            <div class="card-text">
              <h3 class="w-700">Iscriviti al progetto</h3>
              <p class="card-description">
                Lezioni in presenza o corsi di coding online attraverso la
                nostra piattaforma sono a portata di un click. Iscrivi la tua scuola
                ed entra a far parte del futuro con Easycode.
              </p>
              <button
                class="btn-lightblue m-custom mt-4"
                (click)="openModal('S')"
              >
                <span class="button-txt">Iscriviti al progetto</span>
              </button>
            </div>
          </div>
        </div>

        <!--mobile view-->
        <section class="d-block d-md-block d-lg-none" #myElement>
          <ng-container *ngIf="slideSelected == 1">
            <div
              class="col-xl d-flex justify-content-center justify-content-xl-end mb-5 mb-xl-0"
            >
              <div class="isc-card-1 pointer" index="1">
                <img
                  src="../../../assets/img/educatori_digitali.png"
                  alt="iscriviti"
                 
                />
                <div class="card-text">
                  <h3 class="w-700">Diventa un educatore</h3>
                  <p class="card-description">
                    Entra a far parte della nostra squadra in costante crescita
                    di educatori digitali. Mandaci una tua candidatura e ti
                    contatteremo presto!
                  </p>
                  <button class="btn-lightblue m-custom mt-4">
                    <span class="button-txt" (click)="openModal('E')"
                      >Invia la tua candidatura</span
                    >
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="slideSelected == 2">
            <div
            class="col-xl d-flex justify-content-center justify-content-xl-start"
          >
            <div class="isc-card-2 pointer" index="2">
              <img
                src="../../../assets/img/scuole.png"
                alt="scuole"
               
              />
              <div class="card-text">
                <h3 class="w-700">Iscriviti al progetto</h3>
                <p class="card-description">
                  Lezioni in presenza o corsi di coding online attraverso la
                  nostra piattaforma sono a portata di un click. Iscrivi la tua scuola
                  ed entra a far parte del futuro con Easycode.
                </p>
                <button
                  class="btn-lightblue m-custom mt-4"
                  (click)="openModal('S')"
                >
                  <span class="button-txt">Iscriviti al progetto</span>
                </button>
              </div>
            </div>
          </div>
          </ng-container>
        </section>
      </div>
    </div>
  </div>

  <div class="row d-block d-md-block d-lg-none">
    <div
      class="col pointer-slide"
      style="
        display: flex;
        justify-content: center;
        gap: 9px;
        padding-bottom: 80px;
        padding-top: 64px;
      "
    >
      <div (click)="changeSlide(1)" class="pointer">
        <img src="assets/img/slide-selected.svg" *ngIf="slideSelected == 1" alt="" aria-hidden="true" />
        <img src="assets/img/slide-unselected.svg" *ngIf="slideSelected != 1" alt="" aria-hidden="true" />
      </div>
      <div (click)="changeSlide(2)" class="pointer">
        <img src="assets/img/slide-selected.svg" *ngIf="slideSelected == 2" alt="" aria-hidden="true" />
        <img src="assets/img/slide-unselected.svg" *ngIf="slideSelected != 2" alt="" aria-hidden="true" />
      </div>
    </div>
  </div>
</div>
